const loadItems = (button) => {
  const totalPagesInput = document.querySelector('[data-total-pages]');
  const currentPageInput = document.querySelector('[data-current-page]');
  const nextUrlInput = document.querySelector('[data-next-url]');

  const totalPages = parseInt(totalPagesInput.value);
  let currentPage = parseInt(currentPageInput.value);
  const currentPageScroll = currentPage + 1;

  currentPage = currentPage + 1;
  const nextUrl = nextUrlInput.value.replace(/page=[0-9]+/, 'page=' + currentPage);
  const nextUrlScroll = nextUrlInput.value.replace(/page=[0-9]+/, 'page=' + currentPageScroll);
  currentPageInput.value = currentPage;

  button.setAttribute('disabled', '');
  button.classList.add('loading');

  fetch(nextUrl)
    .then((response) => response.text())
    .then((responseHTML) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(responseHTML, 'text/html');
      const newGrid = doc.querySelector('.load-more-grid');
      const currentGrid = document.querySelector('.load-more-grid');

      if (newGrid && currentGrid) {
        currentGrid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
      }

      try {
        colorSwatches();
      } catch (err) {}
    })
    .catch((err) => {
      console.error(err);
    })
    .finally(() => {
      if (currentPage <= totalPages) {
        const scrollData = document.querySelector('.infinite-scroll__data');
        if (scrollData && currentPage != totalPages) {
          const scrollNextUrlInput = scrollData.querySelector('input[data-next-url]');
          const scrollCurrentPageInput = scrollData.querySelector('input[data-current-page]');

          scrollNextUrlInput.dataset.nextUrl = nextUrlScroll;
          scrollNextUrlInput.value = nextUrlScroll;
          scrollCurrentPageInput.dataset.currentPage = currentPage;
          scrollCurrentPageInput.value = currentPage;
          checkVisibility();
        }
        button.removeAttribute('disabled');
        button.classList.remove('loading');
        if (currentPage == totalPages) {
          button.remove();
        }
      }
    });
};

const checkVisibility = () => {
  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
  spinnerList.forEach((spinner) => {
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadItems(spinner);
        }
      });
    });

    sectionObserver.observe(spinner);
  });
};

function loadMore() {
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    };
  });

  checkVisibility();
}

(function () {
  loadMore();
})();